module.exports = __webpack_public_path__ + "static/media/kingpenguin.95129c7c.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/kingpenguin.svg
 ** module id = 431
 ** module chunks = 0
 **/